import {Pipe, PipeTransform} from "@angular/core";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";

@Pipe({name: 'prosent', pure: true, standalone: true})
export class FormaterProsentPipe implements PipeTransform {
    constructor() {}

    transform(value: any): string | null {
        return erIkkeNil(value) ? `${value}%` : '';
    }
}
